import { render } from "./LevelUpDialog.vue?vue&type=template&id=982963e8&scoped=true"
import script from "./LevelUpDialog.vue?vue&type=script&lang=js"
export * from "./LevelUpDialog.vue?vue&type=script&lang=js"

import "./LevelUpDialog.vue?vue&type=style&index=0&id=982963e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-982963e8"]])

export default __exports__